import { api } from ".";

export interface ICptCodeQuantityRecommendation {
  cptCode: string;
  suggestedQuantity: number;
  occurrenceRate: number;
  sampleCount: number;
}

const cptCodeQuantityRecommendationsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getCptCodeQuantityRecommendations: builder.mutation<
      {
        data: { recommendations: ICptCodeQuantityRecommendation[] };
        message: string;
      },
      { accountId: string; includedCptCodes: string[] }
    >({
      query: ({ accountId, includedCptCodes }) => ({
        url: "/cpt-code-quantities/recommendations",
        method: "POST",
        body: { accountId, includedCptCodes },
      }),
    }),
  }),
});

export const { useGetCptCodeQuantityRecommendationsMutation } =
  cptCodeQuantityRecommendationsQueries;
